<div *ngIf="studentForm" [formGroup]="studentForm">
    <p-toast></p-toast>
    <button (click)="updateStudent()">Submit</button>
    <div>
        ID: {{selectedStudent!.id!}}
        Student
        <input formControlName="firstName">
        <input formControlName="lastName">
        <p-dropdown placeholder="language" [options]="languages" optionLabel="name" formControlName="language">
        </p-dropdown>
        <p-dropdown placeholder="gender" [options]="genders" optionLabel="name" formControlName="gender"></p-dropdown>
        <input formControlName="birthday">
        <p-dropdown placeholder="nationality" [options]="nationalities" optionLabel="name"
            formControlName="nationality"></p-dropdown>
    </div>
    <div>
        Contact
        <input formControlName="mobile">
        <input formControlName="phoneNumber">
        <input formControlName="email">
    </div>
    <div>
        Address
        <input formControlName="address">
        <input formControlName="postCode">
        <input formControlName="city">
        <input formControlName="country">
        <p-dropdown placeholder="country" [options]="nationalities" optionLabel="name" formControlName="country">
        </p-dropdown>
    </div>
    <div>
        Preferences
        <input formControlName="allergies">
        <input formControlName="hobbies">
        <p-dropdown [options]="responseList" formControlName="smokingOk"></p-dropdown>
        <p-dropdown [options]="responseList" formControlName="kidsOk"></p-dropdown>
        <p-dropdown [options]="responseList" formControlName="petsOk"></p-dropdown>
        <input formControlName="otherPreference">
    </div>

</div>
Comments
<div [formGroup]="commentForm!">
    <input formControlName="body">
    <button (click)="postComment()">Submit</button>
</div>
<div *ngIf="selectedStudent">

    <p *ngFor="let comment of selectedStudent.studentComments">
        {{comment.body}}
    </p>
</div>